import { uniqueId } from "lodash";
import React, { InputHTMLAttributes, useState } from "react";
import { TextInput } from "../../../Korbantech/components/Inputs/TextInput";
import { CheckItem } from "../../CheckItem";

export const OscTrueFalseInput = React.forwardRef<HTMLInputElement, Props>(({ isCheck,descriptionText,label, needDescription, ...props }, ref) => {

    const [yesOrNo, setYesOrNo] = useState<string>(isCheck ? "y":"n")
    const name = uniqueId()
    return (
        <div>
            <label className="font-semibold text-gray-800">{label}</label>
            <div className="flex my-2">
                <div className="border border-gray-600 rounded mr-6 px-2 py-1">
                    <CheckItem label={"Sim"} defaultChecked={yesOrNo === "y" && true}
                        name={needDescription ? name : props.name} type="radio" onClick={() => setYesOrNo('y')}
                    />
                </div>
                <div className="border border-gray-600 rounded px-2 py-1">
                    <CheckItem label={"Não"} defaultChecked={yesOrNo === "n" && true}
                        name={needDescription ? name : props.name} type="radio" onClick={() => setYesOrNo('n')}
                    />
                </div>
            </div>
            {yesOrNo === 'y' && needDescription &&
                <TextInput {...props} className='rounded-lg' placeholder={"Descreva"} defaultValue={descriptionText && descriptionText} />}
        </div>
    )
})

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label: string,
    needDescription?: boolean
    isCheck?:boolean
    descriptionText?:string
}
